import { AlloyButton } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { useMyEquipment } from '../../../../hooks';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const actions = {
  ADD_EQUIPMENT: 'AddEquipment',
  ADD_SERIAL_NUMBER: 'AddSerialNumber',
  SELECT_EQUIPMENT: 'SelectEquipment'
};

const SelectEquipmentWidget = ({
  className,
  openAddDrawer,
  openEditDrawer,
  openSelectDrawer
}) => {
  const [t] = useTranslation();
  const { openSaveEquipment } = useMyEquipment();
  const { ADD_EQUIPMENT, ADD_SERIAL_NUMBER, SELECT_EQUIPMENT } = actions;

  const [option, setOption] = useState();
  // ** useActions is used to bind Dispatch to actions creators. These are required by AddEquipment, EditEquipment and SelectEquipment *//
  const equipmentList = useSelector(
    s => s.myEquipment?.equipments?.myEquipmentList
  );
  const hasUserStoredEquipments =
    (Array.isArray(equipmentList) && equipmentList.length > 0) || false;
  const isEquipmentSelected = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.model
  );
  const isQRCodeTempEquipment = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.isQRCodeTempEquipment
  );
  const renderOptions = {
    [ADD_EQUIPMENT]: {
      onClick: openAddDrawer,
      title: t('MEQ_ADD_EQUIP'),
      cta_text: t('MEQ_ADD_YOUR_EQUIP'),
      message: t('MEQ_PARTS_FIT_CTA')
    },
    [ADD_SERIAL_NUMBER]: {
      onClick: () =>
        isQRCodeTempEquipment ? openSaveEquipment() : openEditDrawer(),
      message: t('ENTER_SERIAL_FOR_FIT_PARTS')
    },
    [SELECT_EQUIPMENT]: {
      onClick: openSelectDrawer,
      title: t('SELECT_EQUIPMENT'),
      cta_text: t('SELECT_YOUR_EQUIPMENT'),
      message: t('MEQ_PARTS_FIT_CTA')
    }
  };

  useEffect(() => {
    if (isEquipmentSelected) {
      setOption(ADD_SERIAL_NUMBER);
    } else if (hasUserStoredEquipments) {
      setOption(SELECT_EQUIPMENT);
    } else {
      setOption(ADD_EQUIPMENT);
    }
  }, [
    ADD_EQUIPMENT,
    ADD_SERIAL_NUMBER,
    SELECT_EQUIPMENT,
    hasUserStoredEquipments,
    isEquipmentSelected
  ]);

  const { title, message, cta_text, onClick } = renderOptions[option] || {};

  return (
    <>
      {isEquipmentSelected ? (
        <p className={cx(className, 'text-univers')}>
          <AlloyButton
            buttonType="link"
            onClick={onClick}
            className="p-0 m-0 align-middle"
          >
            {t('MEQ_ENTER_SERIAL_CAT1')}
          </AlloyButton>
          <span className="text-sm align-middle text-univers">{` ${t(
            'MEQ_ENTER_SERIAL_CAT2'
          )}`}</span>
        </p>
      ) : (
        <div className={cx(className, 'text-center text-md-start')}>
          <h3 className="h3 display-2 mb-0">{title}</h3>
          <p className="text-xl color-dark-gray text-univers mb-0">{message}</p>
          <AlloyButton
            buttonType="primary"
            size="dynamic"
            className={cx('mt-3 w-100 w-lg-auto')}
            onClick={onClick}
          >
            {cta_text}
          </AlloyButton>
        </div>
      )}
    </>
  );
};

SelectEquipmentWidget.propTypes = {
  className: PropTypes.string,
  openAddDrawer: PropTypes.func,
  openEditDrawer: PropTypes.func,
  openSelectDrawer: PropTypes.func
};

export default SelectEquipmentWidget;
